(function () {
  'use strict';

  function search () {
    function link (scope, el) {
      let selected, selectedIndex;
      // this will determine the direction of the selection
      const direction = {
        40: goNext,
        38: goPrev
      };
      // this is downwards
      function goNext () {
        selectedIndex++;
      }
      // this is updwards
      function goPrev () {
        selectedIndex--;
      }
      // keydown event
      el.keydown(function (e) {
        // check if the its the down or up buttons
        scope.alreadySelected = false;

        if (e.which === 27) {
          scope.alreadySelected = true;
          if (selected) {
            selected.removeClass('suggestion-selected');
            selected = selectedIndex = null;
          }
        }

        if (!scope.$$phase) {
          scope.$apply();
        }

        if (e.which === 40 || e.which === 38) {
          const liEl = el.find('.suggestion-item');
          // check if there is suggestion lists
          if (liEl.length) {
            // change item index
            direction[e.which]();
            // it should set to the last index of the list when user is on the first item on the list when pressing up
            if (selectedIndex === -1) {
              selectedIndex = liEl.length - 1;
            }
            // it should set to the first index of the list when user is on the last item of the list when pressing down
            if (selectedIndex >= liEl.length) {
              selectedIndex = 0;
            }

            if (selected) {
              // IMPORTANT remove class so that it won't duplicate
              selected.removeClass('suggestion-selected');
              selected = liEl.eq(selectedIndex).addClass('suggestion-selected');
            } else {
              selectedIndex = 0;
              selected = liEl.eq(0).addClass('suggestion-selected');
            }
          } else {
            selected = selectedIndex = null;
          }
        }

        if (e.which === 13 && selected) {
          scope.alreadySelected = true;
          // IMPORTANT: should have callback as 2nd parameter so that search will know what to do with data being fetched
          scope.search(JSON.parse(selected.attr('rowdata')), 'add');
          selected.removeClass('suggestion-selected');
          selected = selectedIndex = null;
        }
      });
    }

    return {
      restrict: 'E',
      link: link,
      templateUrl: 'components/recipients/map/search.html'
    };
  }

  angular.module('web2print.recipients')
    .directive('search', search);
})();
